import React, { useEffect, useRef, useState } from 'react';
import useInfiniteScroll from 'react-infinite-scroll-hook';
import GoUpBtn from '../../common/GoUpBtn';
import Loader from '../../common/Loader';
import MessageInfo from '../../common/MessageInfo';
import SportSelectionMenu from '../../common/SportSelectionMenu';
import PrematchContext from '../../contexts/PrematchContext';
import { useFetchSeoSettings } from '../../data/fetchSeoSettings';
import { useFetchTournamentsByDate } from '../../data/fetchTournamentsByDate';
import { parseMacroGruppi } from '../../data/parseMacroGruppi';
import { SeoContext } from '../../data/seo/SeoContextProvider';
import SeoMainContainer from '../../data/seo/SeoMainContainer';
import SeoMetaTags from '../../data/seo/SeoMetaTags';
import { useHandleSeoSettings } from '../../data/seo/seoUtils';
import { classIf, filterSearchResults, getConfiguration, getMatchIdOrStageId, getPrincipaleOPrimoMacroGruppo, handleMouseOverTooltip, hideTooltip, iconSportCssClass } from '../../data/utils';
import { WidgetContext } from '../../data/widgets/WidgetContext';
import { ReactComponent as CloseIcon } from '../../icons/menu.svg';
import { getLabel } from '../../InitData';
import { useScrollableData } from '../../scrollableData';
import { useLayout } from '../../UISettingsProvider';
import FullScreenButton from '../prematch-home/prematch-tournament-buttons/FullScreenButton';
import PrematchBetGroupsNew from '../prematch-home/PrematchBetGroupsNew';
import PrematchTournamentMatches from '../prematch-home/PrematchTournamentMatches';
import ContentWrapper from './ContentWrapper';
import Match from './Match';
import { ReactComponent as PrintIcon } from '../../icons/print.svg';
import PrintOddsButton from './PrintOddsButton';
import DaysButtons from '../../common/menu/prematch/DaysButtons';
import PrematchBetGroupsNewAlt from '../prematch-home/PrematchBetGroupsNewAlt';
import DaysButtonsAlt from '../../common/menu/prematch/DaysButtonsAlt';

function getSortType() {
    let sortType = 'league';
    const item = localStorage.getItem('xs_prematch_sort_type');
    if (item) {
        sortType = item;
    }
    return sortType;
}

function getTimesBySortType(times, sortType) {
    if (sortType === 'asc') {
        return times.sort();
    } else {
        return times.sort().reverse();
    }
}

function MatchesByDate(props) {
    const conf = getConfiguration();
    const cfgSeo = conf.seo;
    const layout = useLayout();
    const prematchContext = React.useContext(PrematchContext);
    const widgetContext = React.useContext(WidgetContext);
    const seoContext = React.useContext(SeoContext);
    const sport = prematchContext.daySelection.sport;
    const currentSport = useRef(prematchContext.daySelection.sport);
    const [seoSettingsState] = useFetchSeoSettings(seoContext.pathname, false, cfgSeo);
    const isShopMode = window.appConfig?.SHOP_MODE;

    useHandleSeoSettings(seoSettingsState);

    const [state, setState] = useState({
        data: null,
        sportFetch: sport,
        sport,
        macrogruppo: null,
        aggregata: null,
        aggregataFetch: sport.aggregata,
        match: null,
        sortType: getSortType(),
        update(updt) {
            setState(prev => {
                return { ...prev, ...updt };
            });
        },
        setData(data) {
            let macrogruppo = this.macrogruppoFetch;
            if (macrogruppo == null) {
                macrogruppo = data.macrogruppi.find(mg => mg.id === this.sportFetch.macrogruppo) || getPrincipaleOPrimoMacroGruppo(data.macrogruppi);
            }
            let firstMatch = this.match;
            try {
                if (firstMatch == null) {
                    const tournaments = data.tournamentsByTime.get(data.times[0]);
                    firstMatch = tournaments[0].matches[0];
                    const mg = data.macrogruppi.find(mg => mg.id === firstMatch.openMacrogruppo);
                    if (mg && this.macrogruppo && mg.id !== this.macrogruppo.id) {
                        macrogruppo = mg;
                    }
                }
                firstMatch.macrogruppi = parseMacroGruppi(firstMatch.gruppoById, firstMatch.sportRef, firstMatch.isLive);
            } catch (e) {
                console.error(e);
            }
            this.update({ data, sport: this.sportFetch, macrogruppo, aggregata: this.aggregataFetch, match: firstMatch });
        },
        changeDaySelection(sport) {
            this.update({ sportFetch: sport, aggregataFetch: sport.aggregata, match: null, sortType: 'league' });
        },
        changeSport(sportId) {
            const sportFetch = this.data.sportById.get(sportId);
            this.update({ sportFetch, macrogruppoFetch: null, aggregataFetch: sportFetch.aggregata });
        },
        changeMacrogruppo(macrogruppo) {
            if (this.macrogruppo == null || macrogruppo.id !== this.macrogruppo.id) {
                if (macrogruppo.aggregate[0].idAggregata !== this.aggregata) {
                    this.update({ macrogruppoFetch: macrogruppo, aggregataFetch: macrogruppo.aggregate[0].idAggregata });
                } else {
                    this.update({ macrogruppoFetch: macrogruppo, macrogruppo });
                }
            }
        },
        changeAggregata(aggregata) {
            if (this.aggregata !== aggregata) {
                this.update({ aggregataFetch: aggregata });
            }
        },
        changeMatch(match) {
            this.update({ match });
        },
        setSortType(sortType) {
            if (sortType !== this.sortType) {
                this.update({ sortType });
                localStorage.setItem('xs_prematch_sort_type', sortType);
            }
        }
    });
    const [sortMenuToggled, setSortMenuToggled] = useState(false);
    const [search, setSearch] = useState(null);

    function handleClose() {
        prematchContext.closeAllTournaments();
    }

    function openMatch(match, url) {
        match.macrogruppi = parseMacroGruppi(match.gruppoById, match.sportRef, match.isLive)
        state.changeMatch(match);
    }

    function changeSport(sportId) {
        state.changeSport(sportId);
    }

    function changeMacrogruppo(mg) {
        state.changeMacrogruppo(mg);
    }

    function changeAggregata(ag) {
        state.changeAggregata(ag);
    }

    function changeSortType(type) {
        setSortMenuToggled(!sortMenuToggled);
        state.setSortType(type);
    }

    const data = state.data;
    const [request] = useFetchTournamentsByDate(prematchContext.daySelection.date, state.sportFetch.id, state.aggregataFetch);

    const [showLoader, setShowLoader] = useState(true);
    useEffect(function () {
        let timeout = null;
        if (request.isLoading) {
            timeout = setTimeout(function () {
                setShowLoader(true);
            }, conf.lspt);
        } else {
            clearTimeout(timeout);
            //setShowLoader(false);
            if (!request.isError) {
                state.setData(request.data);
                currentSport.current = state.sportFetch.id
            }
        }

        return () => {
            clearInterval(timeout);
        };
    }, [request]);

    useEffect(function () {
        if (data != null) {
            let tournaments = data.tournaments;
            if (state.sortType !== 'league') {
                tournaments = [];
                const times = data.times;
                getTimesBySortType(times, state.sortType).forEach((time, timeIndex) => {
                    const tournamentsByTime = data.tournamentsByTime.get(time);
                    tournamentsByTime && tournamentsByTime.forEach((tournament, tournamentIndex) => {
                        const uniqueId = `${timeIndex}_${tournamentIndex}`;
                        const matches = tournament.matches;

                        if (matches.length > 0) {
                            tournaments.push({
                                id: tournament.id,
                                uniqueId,
                                time,
                                desc: tournament.desc,
                                categoryRef: tournament.categoryRef,
                                sportRef: tournament.sportRef,
                                matches,
                                aggregate: data.aggregate
                            });
                        }
                    });
                });
            }
            scrollableData.resetData(tournaments, 5);
            setTournaments(tournaments);
            setShowLoader(false);
        }
    }, [data, state.sortType]);
    const [tournaments, setTournaments] = useState([]);

    // Reset selections when component is unmounted
    useEffect(function () {
        return () => {
            prematchContext.setDaySport(null);
            prematchContext.setDayCountry(null);
        }
    }, []);

    useEffect(() => {
        if (data != null) {
            state.changeDaySelection(prematchContext.daySelection.sport);
            scrollableData.resetData(data.tournaments, 5);
        }
    }, [prematchContext.daySelection]);

    useEffect(function () {
        const settings = {
            widgetS5Layout: '#3'
        };
        if (state.isLiveMatch) {
            Object.assign(settings, {
                widgetStartCollapsed: true,
                widgetContainerId: null, //imposto container null, il container lo decide il component che visualizza il match
                widgetMatchId: getMatchIdOrStageId(state.match)
            });
        }
        widgetContext.setWidget(settings);
    }, [state.match]);

    const [scrollableData] = useScrollableData([], 5, 1);
    const infiniteRef = useInfiniteScroll({
        loading: scrollableData.loading,
        hasNextPage: scrollableData.hasMoreItems,
        onLoadMore: scrollableData.getMoreData,
        scrollContainer: scrollableData.container
    });

    const filterByCountry = currentSport.current == prematchContext.daySport && prematchContext.dayCountry;
    const items = (scrollableData.enabled && !filterByCountry) ? scrollableData.visibleItems : tournaments;

    const icoSport = iconSportCssClass(state.sport.id, props.iconClass);
    const [toggled, setToggled] = useState(props.toggled);

    return (
        <>
            <SeoMetaTags />

            <div className={"griglia-centrale-sport col stringimento-sidebar griglia__wh " + layout.order.divCentrale} id="div-centrale">
                <div className="contenitore-schedine-sport">
                    <ContentWrapper>
                        <>
                            <GoUpBtn />
                            <div className="titolo-blocco-sport bg-nero bianco pointer">
                                <i className="fa fa-times margine-dx align-self-center" onClick={handleClose}></i>
                                <div className="nome-competizione-sport">
                                    <div className={`img-fluid margine-dx ico-sport ${icoSport}`}></div>
                                    <span className="grassetto">{state.sport.descrizione}</span>
                                </div>
                                <div className="icone-controllo-sport-centrale">
                                    <div className="ricerca-titolo-blocco-sport mr-2">
                                        <input type="text" placeholder={getLabel('general.search_match')} name="search" onChange={(event) => setSearch(event.target.value)} />
                                    </div>
                                    <FullScreenButton />
                                    <CloseIcon
                                        className="pointer"
                                        onClick={handleClose}
                                        onMouseOver={handleMouseOverTooltip}
                                        onMouseOut={hideTooltip}
                                        data-desc={getLabel('prematch_page.control_icon.close_all')}
                                    />
                                </div>
                            </div>
                            {(showLoader || request.isError || data == null) ?
                                <Loader error={request.isError} />
                                :
                                <>
                                    <div className="tab-content d-flex position-relative" id={"tabellaCompetizione-" + state.sport.id}>
                                        <div className="partite-del-giorno tab-pane fade show active overflow-visible d-flex" role="tabpanel">
                                            <SportSelectionMenu sports={data.sport}
                                                selected={state.sport.id}
                                                forceRows={props.forceRows}
                                                showSortButton={true}
                                                changeSport={changeSport} />
                                            {!isShopMode &&
                                                <PrintOddsButton date={prematchContext.daySelection.date}
                                                    agg={state.aggregata}
                                                    tournaments={tournaments}
                                                    bets={state.data.matches[0].bets}
                                                />
                                            }
                                            <div className="sort-button position-relative" onClick={() => { setSortMenuToggled(!sortMenuToggled) }}>
                                                <i className="fa fa-sort-alpha-down"></i>
                                                <span>{getLabel('sort_menu.title')}</span>
                                                {sortMenuToggled &&
                                                    <div className="nav-slider-menu">
                                                        <div className="nav-slider-menu-close-button push-right pointer" onClick={() => { setSortMenuToggled(!sortMenuToggled) }}>
                                                            <i className="fa fa-times"></i>
                                                        </div>
                                                        <div className={"nav-slider-menu-row pointer" + classIf(state.sortType === 'league', 'selected')} onClick={() => { changeSortType('league') }}>
                                                            <i className="fa fa-sort-alpha-down"></i>
                                                            <span>{getLabel('sort_menu.sort_by_tournament')}</span>
                                                        </div>
                                                        <div className={"nav-slider-menu-row pointer" + classIf(state.sortType === 'desc', 'selected')} onClick={() => { changeSortType('desc') }}>
                                                            <i className="fa fa-sort-down"></i>
                                                            <span>{getLabel('sort_menu.sort_by_chronological_order')}</span>
                                                        </div>
                                                        <div className={"nav-slider-menu-row pointer" + classIf(state.sortType === 'asc', 'selected')} onClick={() => { changeSortType('asc') }}>
                                                            <i className="fa fa-sort-up"></i>
                                                            <span>{getLabel('sort_menu.sort_by_reverse_chronological_order')}</span>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="partite-del-giorno tab-pane fade show active overflow-visible" role="tabpanel">
                                        {conf.iwh ?
                                            <>
                                                <div className='daysButton__wrapper'>
                                                    <div className='daysButton__wh'> <DaysButtonsAlt changeSport={changeSport} selected={state.sport.id} /></div>
                                                    <div className="ricerca-titolo-blocco-sport mr-2 ricerca__wh">
                                                        <input type="text" placeholder={getLabel('general.search_match')} name="search" onChange={(event) => setSearch(event.target.value)} />
                                                    </div>
                                                </div>
                                                <PrematchBetGroupsNewAlt
                                                    macrogruppi={data.macrogruppi}
                                                    macrogruppo={state.macrogruppo}
                                                    changeMacrogruppo={changeMacrogruppo}
                                                    aggregate={data.aggregate}
                                                    aggregata={state.aggregata}
                                                    changeAggregata={changeAggregata}
                                                /></>
                                            :
                                            <PrematchBetGroupsNew macrogruppi={data.macrogruppi}
                                                macrogruppo={state.macrogruppo}
                                                changeMacrogruppo={changeMacrogruppo}
                                                aggregate={data.aggregate}
                                                aggregata={state.aggregata}
                                                changeAggregata={changeAggregata} />
                                        }
                                        <div className="contenitore-table-grande">
                                            <div ref={scrollableData.enabled ? infiniteRef : null} >
                                                {items.length > 0 ?
                                                    items.filter(t => filterByCountry ? t.categoryRef === parseInt(prematchContext.dayCountry, 10) : true).map(t => {
                                                        const uniqueId = `${t.sportRef}_${t.categoryRef}_${t.id}`;
                                                        const sport = props.data?.sportById?.[t.sportRef];
                                                        const country = sport?.categoryById?.[t.categoryRef];
                                                        const desc = country ? `${country.descrizione} - ${t.desc}` : t.desc;
                                                        let matches = t.matches;
                                                        if (search && search.length > 0) {
                                                            matches = filterSearchResults(matches, search, 'MATCH', (match) => match.desc);
                                                        }
                                                        if (matches.length === 0) {
                                                            return null;
                                                        }
                                                        return <PrematchTournamentMatches key={t.uniqueId || t.id}
                                                            uniqueId={uniqueId}
                                                            time={t.time}
                                                            desc={desc}
                                                            matches={matches}
                                                            aggregate={data.aggregate}
                                                            aggregata={state.aggregata}
                                                            openMatch={openMatch} />
                                                    })
                                                    :
                                                    <div className="margine-su">
                                                        <MessageInfo message={getLabel('general.no_events')} />
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    {(!scrollableData.enabled || !scrollableData.hasMoreItems) &&
                                        <SeoMainContainer />
                                    }
                                </>
                            }
                        </>
                        <Match match={state.match} />
                    </ContentWrapper>
                </div>
            </div>
        </>
    );
}

export default MatchesByDate;